import React from "react";

export const APPLY_FLOW_STEPS = [
  {
    id: 1,
    title: "Aadhaar Verify",
    subtitle: "Identity check",
  },
  {
    id: 2,
    title: "Personal & Contact",
    subtitle: "Details & mobile OTP",
  },
  {
    id: 3,
    title: "Loan & Documents",
    subtitle: "Apply & upload",
  },
];

const ApplyFlowStepper = ({ currentStep }) => {
  return (
    <div className="apply-flow-stepper" aria-label="Application progress">
      {APPLY_FLOW_STEPS.map((step, index) => {
        const isCompleted = currentStep > step.id;
        const isActive = currentStep === step.id;

        return (
          <React.Fragment key={step.id}>
            <div
              className={`apply-flow-stepper__item ${
                isActive ? "is-active" : ""
              } ${isCompleted ? "is-completed" : ""}`}
            >
              <div className="apply-flow-stepper__circle">
                {isCompleted ? "\u2713" : step.id}
              </div>
              <div className="apply-flow-stepper__text">
                <span className="apply-flow-stepper__title">{step.title}</span>
                <span className="apply-flow-stepper__subtitle">
                  {step.subtitle}
                </span>
              </div>
            </div>
            {index < APPLY_FLOW_STEPS.length - 1 && (
              <div
                className={`apply-flow-stepper__line ${
                  isCompleted ? "is-completed" : ""
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ApplyFlowStepper;
